<template>
	<div class="help-content">
		<!--pre>{{ $route.name }}</pre-->
		<div v-if="collection.data.length">
			<shape src="/static/svg/help.svg" @click.native="onClick"/>
			<modal-box v-if="modalBox.open" @close="onModalBoxClose" header="Help">
				<!--pre>{{ collection }}</pre-->
				<div v-html="current.content"></div>
			</modal-box>
		</div>
	</div>
</template>

<script>
import ApiCollection from '@/classes/api/ApiCollection'
export default {
	data () {
		return {
			collection: new ApiCollection(),
			modalBox: {
				open: false
			}
		}
	},
	computed: {
		current () {
			return this.collection.data.find(ele => ele.lang == this.$i18n.locale) || {}
		}
	},
	watch: {
		'$route': {
			handler (to, from) {
				//console.log(to, from)
				if (from == undefined || to.name != from.name) {
					const routeName = (to.name).toLowerCase() || ''
					this.getHelp(routeName)
				}
			},
			immediate: true
		}
	},
	methods: {
		onClick () {
			this.modalBox.open = true
		},
		onModalBoxClose () {
			this.modalBox.open = false
		},
		getHelp (routeName) {
			this.collection.loading = true
			this.collection.data = []
			this.$api.help.getHelpContent(this, routeName)
				.then(response => {
					this.$log.info('help', 'help.getHelpContent OK', response)()
					this.collection.data = response.body.length ? response.body : []
				})
				.catch(error => {
					this.$log.error('help', 'help.getHelpContent ERROR', error)()
					this.collection.error = error
				})
				.finally(() => {
					this.collection.loading = false
				})
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/components/help/HelpContent.vue